import { render, staticRenderFns } from "./DialogShareEvent.vue?vue&type=template&id=4b77543c&scoped=true"
import script from "./DialogShareEvent.vue?vue&type=script&lang=js"
export * from "./DialogShareEvent.vue?vue&type=script&lang=js"
import style0 from "./DialogShareEvent.vue?vue&type=style&index=0&id=4b77543c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77543c",
  null
  
)

export default component.exports